// Small numeric helpers that mirror rust_decimal rounding used by crates/pipeline_domain.

export function num(v: string | number | null | undefined): number | null {
  if (v === null || v === undefined || v === "") return null;
  const n = typeof v === "number" ? v : Number(v);
  return Number.isFinite(n) ? n : null;
}

const EPS = 1e-9;

/** Round half away from zero (rust_decimal MidpointAwayFromZero). */
export function roundAway(x: number, dp: number): number {
  const f = 10 ** dp;
  const y = Math.abs(x) * f;
  const r = Math.floor(y + 0.5 + EPS);
  return (Math.sign(x) * r) / f;
}

/** Round half to even (rust_decimal `round_dp`, banker's rounding). */
export function roundEven(x: number, dp: number): number {
  const f = 10 ** dp;
  const y = x * f;
  const fl = Math.floor(y);
  const diff = y - fl;
  let r: number;
  if (Math.abs(diff - 0.5) < EPS) r = fl % 2 === 0 ? fl : fl + 1;
  else r = Math.round(y);
  return r / f;
}
